/**
 * 만료된 접근 토큰을 새로 발급받는다. `POST /app/auths/renewal`.
 *
 * `pages/api/axiosInstance.ts` 의 401 처리에서만 부른다. 화면에서 직접 부를 일은 없다.
 *
 * 주의: 인증이 붙은 `axiosInstance` 가 아니라 인증이 없는 `axiosPublic` 을 쓴다.
 * 갱신 요청 자체가 401 을 받으면 다시 갱신을 시도하게 되어 끝없이 반복되기 때문이다.
 * 갱신에 필요한 refresh token 은 헤더가 아니라 브라우저 쿠키로 오간다.
 * 그래서 `withCredentials` 설정이 켜져 있어야 하고, 백엔드도 이 앱 주소를 허용 목록에 넣어야 한다.
 */
import publicApi from "pages/api/axiosPublic";

interface RefreshTokenResponse {
  isSuccess: boolean;
  code: number;
  message: string;
  result: {
    accessToken: string;
    userId: string;
  };
}

/**
 * 새 접근 토큰을 받아 온다.
 * @returns 성공하면 응답 본문 전체(`result.accessToken`, `result.userId` 포함).
 *          실패하면 예외를 던지지 않고 null 을 돌려준다.
 *          부르는 쪽에서 null 이면 로그아웃 처리로 넘어간다.
 */
export const renewAccessToken =
  async (): Promise<RefreshTokenResponse | null> => {
    try {
      // 토큰 재발급 API 요청
      const response = await publicApi.post<RefreshTokenResponse>(
        "/app/auths/renewal"
      );

      console.log("토큰 재발급 성공:", response.data);

      // 반환된 데이터 반환
      return response.data;
    } catch (error: any) {
      console.error("토큰 재발급 실패:", error.response?.data || error.message);
      return null;
    }
  };
